import React, {Component} from 'react';
import msparcs from "assets/img/doc1.PNG";
import code from "assets/img/code1.PNG";

class Documentation extends Component {
    render() {
        return (
                <div>


                                        <div className="">
                                            <br />
                                            <p>Portal provides details on parameters, requests, and responses for API,Go to API Documentation page. </p>
                                        <br />
                                        </div>

                                        <div className="p-top-10">

                                            <img src={code} alt={code} className="mSpaceLogo" width={'90%'}/>

                                            <br/>
                                        </div>
                    <div className="clearfix"></div>
                                            <blockquote >
                                                <small>Lets you generate sample of code in popular languages that you can copy and paste it into your own application.</small>
                                                <small>Go to API documentation page, go to respective API and from right side panel select
                                                    your desired language.</small>
                                            </blockquote>






                            </div>
        );
    }
}

export default Documentation;